// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CellContent {
    text-overflow: ellipsis;
    /* Required for text-overflow to do anything */
    white-space: nowrap;
    overflow: hidden;
    padding: 0 10px;
    width: 100%;
    display: flex;
    align-items: center;
    color: var(--datatable-cell-text);
}
.InnerCellContent {
    text-overflow: ellipsis;
    overflow: hidden;
}
.selectedRow {
    color: var(--datatable-cell-text-hover);
}

@media (hover: hover) {
    :host-context(.TableRow:hover) .CellContent {
        background-color: var(--datatable-cell-background-hover) !important;
        color: var(--datatable-cell-text-hover);
    }
}`, "",{"version":3,"sources":["webpack://./src/app/components/datatable/datatable.cell.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,8CAA8C;IAC9C,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,iCAAiC;AACrC;AACA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI,uCAAuC;AAC3C;;AAEA;IACI;QACI,mEAAmE;QACnE,uCAAuC;IAC3C;AACJ","sourcesContent":[".CellContent {\n    text-overflow: ellipsis;\n    /* Required for text-overflow to do anything */\n    white-space: nowrap;\n    overflow: hidden;\n    padding: 0 10px;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    color: var(--datatable-cell-text);\n}\n.InnerCellContent {\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n.selectedRow {\n    color: var(--datatable-cell-text-hover);\n}\n\n@media (hover: hover) {\n    :host-context(.TableRow:hover) .CellContent {\n        background-color: var(--datatable-cell-background-hover) !important;\n        color: var(--datatable-cell-text-hover);\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
